<form
  #cmiPaymentForm
  method="post"
  [action]="actionUrl"
>
  @for (element of paymentElements | keyvalue; track element) {
    <input
      type="hidden"
      [name]="element.key"
      [value]="element.value"
    />
  }
</form>
